<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600" scrollable>
    <v-card v-if="busData.id">
      <v-card-title class="primary white--text">
        HỒ SƠ CHI TIẾT TUYẾN XE
        <v-spacer />
        <v-btn dark icon>
          <v-icon @click="closeDialog">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row class="mt-4 py-3">
          <v-col class="py-0" cols="12">
            <v-row>
              <v-col class="d-flex align-center py-0" cols="12" md="4">
                <p class="mb-0">Tên tuyến</p>
              </v-col>

              <v-col md="8"
                ><p class="mb-0">{{ $_get(busData, 'name', '-') }}</p></v-col
              >
              <v-col class="d-flex align-center py-0" cols="12" md="4">
                <p class="mb-0">Số học sinh tối đa</p>
              </v-col>

              <v-col md="8"
                ><p class="mb-0">{{ $_get(busData, 'data.maxStudent', '-') }}</p></v-col
              >
              <v-col class="d-flex align-center py-0" cols="12" md="4">
                <p class="mb-0">Lái xe</p>
              </v-col>

              <v-col md="8"
                ><p class="mb-0">{{ $_get(busData, 'driver.name', '-') }}</p></v-col
              >
              <v-col class="d-flex align-center py-0" cols="12" md="4">
                <p class="mb-0">Số điện thoại lái xe</p>
              </v-col>

              <v-col md="8"
                ><p class="mb-0">{{ $_get(busData, 'driver.phone', '-') }}</p></v-col
              >
              <v-col class="d-flex align-center py-0" cols="12" md="4">
                <p class="mb-0">Monitor</p>
              </v-col>

              <v-col md="8"
                ><p class="mb-0">{{ $_get(busData, 'monitor.name', '-') }}</p></v-col
              >
              <v-col class="d-flex align-center py-0" cols="12" md="4">
                <p class="mb-0">Số điện thoại monitor</p>
              </v-col>

              <v-col md="8"
                ><p class="mb-0">{{ $_get(busData, 'monitor.phone', '-') }}</p></v-col
              >
              <v-col class="d-flex align-center py-0" cols="12" md="4">
                <p class="mb-0">Tình trạng</p>
              </v-col>
              <v-col md="8">
                <p class="mb-0">{{ $_get(busData, 'status') | busStatus }}</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions v-if="$auth.policies['update-class-info']">
        <v-spacer />
        <v-btn @click="editState" class="ma-2" outlined color="#0D47A1">Sửa hồ sơ tuyến xe</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: { state: Boolean },
  data: () => ({ dialog: false }),
  computed: { ...mapGetters({ busData: 'busDetail/busData' }) },
  methods: {
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },
    editState() {
      this.$emit('edit')
      this.closeDialog()
    },
  },
  watch: {
    state() {
      this.dialog = true
    },
  },
}
</script>

<style>
p {
  color: black;
}
.v-subheader {
  width: 30%;
}
</style>
